import { ACCESSIBILITY_COLOR_MODES } from 'config/accessibilityTheme.config';
import { NAVIGATION_STYLES } from 'store/config/displayOptions.config';
import { CHART_STYLE_OPTIONS } from 'utils/charts/chartStyle.utils';
import { MAP_STYLE_OPTIONS } from 'utils/maps/mapTile.utils';

export const navigationStyleOptions = [
  { label: 'Merlin Slate', value: NAVIGATION_STYLES.MERLIN },
  { label: 'Classic', value: NAVIGATION_STYLES.CLASSIC },
];

export const colorModeOptions = [
  { value: ACCESSIBILITY_COLOR_MODES.DEFAULT, label: 'Default' },
  { value: ACCESSIBILITY_COLOR_MODES.MONOCHROME, label: 'Monochrome' },
  { value: ACCESSIBILITY_COLOR_MODES.ENHANCED_CONTRAST, label: 'Enhanced Contrast' },
  { value: ACCESSIBILITY_COLOR_MODES.HIGH_CONTRAST, label: 'High Contrast' },
];

const accessibilityStyleValues = new Set([
  ACCESSIBILITY_COLOR_MODES.MONOCHROME,
  ACCESSIBILITY_COLOR_MODES.ENHANCED_CONTRAST,
  ACCESSIBILITY_COLOR_MODES.HIGH_CONTRAST,
]);

// Color Mode owns accessibility styles; the map and chart menus list visual styles only.
export const mapStyleOptions = MAP_STYLE_OPTIONS.filter(
  (option) => !accessibilityStyleValues.has(option.value),
);

export const chartStyleOptions = CHART_STYLE_OPTIONS.filter(
  (option) => !accessibilityStyleValues.has(option.value),
);

export const customThemeStyleOption = { value: 'custom', label: 'Custom' };
